import type {
    ReminderSchedulePayload,
    ReminderScheduleResponse,
} from '@/types/apps/reminder-schedule.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

export interface ReminderScheduleServiceInterface {}

type ReminderScheduleListResponse = ApiResponse<
    PaginatedResult<ReminderScheduleResponse>
>;

export class ReminderScheduleService
    implements Updatable, Deletable, Creatable, Indexable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/reminder-schedule',
        detail: (id: string) => `/api/reminder-schedule/${id}`,
    };

    public index(params?: QueryParams): Promise<ReminderScheduleListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public create(
        payload: ReminderSchedulePayload
    ): Promise<ApiResponse<ReminderScheduleResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }

    public update(
        id: string,
        payload: ReminderSchedulePayload
    ): Promise<ApiResponse<ReminderScheduleResponse>> {
        return this.apiClient.putApi(this.endpoints.detail(id), payload);
    }

    public destroy(
        ids: string[],
        isHardDeleted: boolean = true
    ): Promise<ApiResponse<void>> {
        const url = this.endpoints.base();

        return this.apiClient.destroyApi<void>(url, ids, isHardDeleted);
    }
}
